var map = {
	"./ArticlesofAssociationorAnnualReturnZh.jpg": "3957",
	"./ArticlesofAssociationorAnnualReturnhongkong.jpg": "0948",
	"./Basicinformationdocumentsofthecompany.jpg": "337f",
	"./CompanyoperationproofaddressShili.jpg": "26a4",
	"./CompanyoperationproofaddressZh.jpg": "660f",
	"./Companyoperationproofaddresshongkong.jpg": "c092",
	"./Companyshareholdingstructure.jpg": "d371",
	"./articlesofassociation.jpg": "a800",
	"./companyregistrationcertificateZh.jpg": "935e",
	"./companyregistrationcertificatehongkong.jpg": "7c58",
	"./fm.jpg": "f5e4",
	"./license.jpg": "d693",
	"./taxcertificatehongkong.jpg": "3f03",
	"./zhizhao.jpg": "633c",
	"./zm.jpg": "8688"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1a5";